import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ id, num, kicker, title, dark = false, children, className = "", aside = null }) => {
  const headerContent = (
    <>
      <Reveal>
        <p className={`font-mono text-xs uppercase tracking-[0.3em] ${dark ? "text-gold" : "text-terra"}`}>
          {num} — {kicker}
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-6 max-w-3xl font-serif text-3xl font-light leading-[1.15] tracking-tight sm:text-4xl lg:text-5xl">
          {title}
        </h2>
      </Reveal>
    </>
  );

  return (
  <section
    id={id}
    data-testid={`section-${id}`}
    className={`relative overflow-hidden py-24 md:py-36 ${dark ? "bg-forest text-linen" : ""} ${className}`}
  >
    <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
      {aside ? (
        <div className="grid items-center gap-10 lg:grid-cols-2">
          <div>{headerContent}</div>
          <Reveal delay={0.15}>{aside}</Reveal>
        </div>
      ) : (
        headerContent
      )}
      <div className="mt-14 md:mt-20">{children}</div>
    </div>
  </section>
  );
};
